import ContainerBlockGenericType from "../ContainersBlocks/ContainerBlockGenericType";

function PID
    ({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericType
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            flagNumber={20}
            showLabelInput={true}
            userConfiguration={true}
            inputLettersDisabled={true}
        />
    );
}
export default PID

